<template>
    <!-- 全景缩略导航 -->
    <div class="panoThumbnails animated fadeInUp" >
        <div class="thumbnailsBox">
            <ul>
              <li   v-for="(items , index) in menuData.thumbs[meunNowIndex]" :key="index" :class="items.ischeck ? 'vrcheck' : ''">
                <img :src="items.src"  :data-nid="index" @click="checkpanoMenu($event)" :data-sid="items.sid">
                <span>{{items.name}}</span>
              </li>  
            </ul>
        </div>
        <div class="thumbnailsTab" v-if="menuData.classification.length>0">
           <ul>
             <li @click="checkThumbMenu" v-for="(item , index) in menuData.classification" :key="index" :data-mid="index" :class="meunNowIndex==index ? 'check' : ''" >{{item}}</li>
           </ul>
        </div>
    </div>
    <!-- 全景缩略导航 -->
</template>

<style type="text/css">
    .panoThumbnails{ width: 100%; position:fixed; left:0; bottom: 1.1rem; }
    .thumbnailsBox{ width: 100%; height: 1.05rem;     border-bottom: 0.01rem solid rgba(255, 255, 255, 0.2); background-color: rgba(0,0,0,0.5);  }
    .thumbnailsBox ul { width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; overflow-x: auto;-webkit-overflow-scrolling: touch;overflow-scrolling: touch; }
    .thumbnailsBox ul::-webkit-scrollbar {width: 0.05rem;     height: 0.05rem;}
    .thumbnailsBox ul::-webkit-scrollbar-thumb {border-radius: 1rem;-webkit-box-shadow: inset 0 0 0.05px #fb6f1d;background: #fb6f1d;}
    .thumbnailsBox ul::-webkit-scrollbar-track {border-radius: 1rem;background: rgba(222,222,222,1);}
    .thumbnailsBox  ul li{position: relative;border: 0.01rem solid #8c8c8c;margin: 0 0.08rem; cursor: pointer; }
    .thumbnailsBox  ul li.vrcheck{border: 0.02rem solid #f6b64c;}
    .thumbnailsBox ul li img{ width: 0.8rem; height: 0.8rem; }
    .thumbnailsBox ul li span{     position: absolute;
    width: 100%;
    height: 0.28rem;
    line-height: 0.28rem;
    text-align: center;
    color: #fff;
    overflow: hidden;
    font-size: 0.08rem;
    bottom: 0px;    z-index: 99; pointer-events: none;
    left: 0px;
    background-color: rgba(0,0,0,0.8); }
    
    .thumbnailsTab{ width: 100%; height: 0.45rem;  background-color: rgba(0,0,0,0.5); }
    .thumbnailsTab ul{ width: 100%; height: 100%; display: flex; flex-direction: row;color: #fff; text-align: center; font-size: 0.16rem; justify-content: center; align-items: center; }
    .thumbnailsTab ul li{ padding: 0 0.15rem;    line-height: 0.45rem;cursor: pointer; }
    .thumbnailsTab ul li.check{border-bottom: 0.02rem solid #f6b64c; } 


   @media screen and (max-width: 450px) {
    .panoThumbnails{ bottom: 1.8rem; }
    .thumbnailsBox{ height: 1.75rem;}
    .thumbnailsBox ul{ justify-content: flex-start; }
    .thumbnailsBox ul li img{ width: 1.4rem; height: 1.4rem; }
    .thumbnailsBox ul li span{height: 0.4rem;line-height: 0.4rem;font-size: 0.16rem;white-space: nowrap;text-overflow: ellipsis;}
    .thumbnailsBox ul::-webkit-scrollbar {width: 0px;     height: 0px;}
    .thumbnailsBox ul::-webkit-scrollbar-thumb {border-radius: 0rem;-webkit-box-shadow: inset 0 0 0px #000;background: normal;}
    .thumbnailsBox ul::-webkit-scrollbar-track {border-radius: 0rem;background: normal;}
    .thumbnailsTab ul{font-size: 0.24rem;}
  } 
</style>
<script type="text/javascript">
	export default{
		name:'thumbLists',
		props:['menuData'],
		data(){
			return {
				meunNowIndex:0,
				preNid:0,
				preMid:0
			}
		},
		mounted (){

		},
		methods:{
			checkMenu(e){
				let par=e.toElement.dataset.mid;
				this.menuIndex=par;
				if(par==1){
					this.isFirstMenu=true;
				}else if(par==2){
					this.isFirstMenu=false;
				}
			}
			,checkThumbMenu(e){
				let mid=e.toElement.dataset.mid;
				this.meunNowIndex=mid;
			}
			,checkpanoMenu(e){
				this.menuData.thumbs[this.preMid][this.preNid]['ischeck']=false;
				let nid=e.toElement.dataset.nid;
				this.preNid=nid;
				this.preMid=this.meunNowIndex;
				let data=this.menuData.thumbs[this.meunNowIndex][nid];
				// console.log(e.toElement.dataset.sid);
                krpano.call('loadscene('+e.toElement.dataset.sid+', null, MERGE);' );
				data['ischeck']=true;
			}
			,checkAll(e){
				this.hdTypeNow='活动类型';
				this.hdAreaNow='活动区域';
				let nid=e.toElement.dataset.nid;
				let index=e.toElement.dataset.index;
				this.$emit('checkSelecter',nid,this.menuIndex);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/thumbLists.vue